"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.router = exports.selectQuestion = exports.scrollTop = exports.doScrollTop = void 0;
const effects_1 = require("redux-saga/effects");
const errors_1 = require("src/utils/errors");
const smoothscroll_polyfill_1 = __importDefault(require("smoothscroll-polyfill"));
smoothscroll_polyfill_1.default.polyfill();
function doScrollTop(value) {
    try {
        document.querySelector('html').scrollTop = value;
        document.querySelector('body').scrollTop = value; // для старых андроидов
    }
    catch (_) {
        (0, errors_1.sendError)(new Error('doScrollTop Error'));
    }
}
exports.doScrollTop = doScrollTop;
function* scrollTop() {
    yield (0, effects_1.call)(doScrollTop, 0);
}
exports.scrollTop = scrollTop;
function selectQuestion({ questionIndex }) {
    try {
        const selector = `#q${questionIndex}`;
        const element = document.querySelector(selector);
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
        });
        element.tabIndex = -1;
        element.focus();
    }
    catch (_) {
        (0, errors_1.sendError)(new Error('selectQuestion Error'));
    }
}
exports.selectQuestion = selectQuestion;
function* router() {
    yield (0, effects_1.takeEvery)('MOVE_NEXT_PAGE', scrollTop);
    // @ts-expect-error TS(2769): No overload matches this call.
    yield (0, effects_1.takeEvery)('SCROLL_TO_QUESTION', selectQuestion);
}
exports.router = router;
